import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiPhoneModule } from '../lib/shared-ui-phone.module'
import { PhoneDocsComponent } from './phone-docs/phone-docs.component'
import { PhoneExampleComponent } from './phone-docs/phone-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUiPhoneModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule
  ],
  declarations: [
    PhoneDocsComponent,
    PhoneExampleComponent
  ],
  exports: [
    PhoneDocsComponent
  ]
})
export class SharedUiPhoneDocsModule {}
